import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { formatVersion, sections, toHashLabel } from '../../helpers';
import { AboutSidebarProps } from '../../types';

const linkBaseClasses =
  'mb-1 px-3 py-2 rounded-md transition-colors text-wrap text-gray-800 bg-white hover:bg-gray hover:text-blue';

const activeLinkClasses = 'bg-blue-50 border-blue text-blue font-semibold';

const groupedSections = sections.reduce(
  (acc, section) => {
    if (!acc[section.group]) acc[section.group] = [];
    acc[section.group].push(section);
    return acc;
  },
  {} as Record<string, typeof sections>,
);

const AboutSidebar: React.FC<AboutSidebarProps> = ({ versionsArray, onClick }) => {
  const [searchParams] = useSearchParams();
  const versionParam = searchParams.get('version');
  const sectionParam = searchParams.get('section');

  const isActiveSection = (section: string) => sectionParam === section;
  const isActiveVersion = (version: string) => versionParam === version;

  return (
    <div className="w-full max-w-[320px] lg:mb-6">
      <div className="bg-white rounded-xl shadow-sm">
        <div className="p-3">
          {Object.entries(groupedSections).map(([group, items]) => (
            <div key={group} className={group !== 'Statistics' ? 'mt-3' : ''}>
              <div className="uppercase font-bold text-lg mb-2 tracking-wider text-blue">{group}</div>
              <div className="flex flex-col gap-1">
                {items.map(({ label, value }) => (
                  <Link
                    key={value}
                    to={`?section=${value}`}
                    className={`${linkBaseClasses} ${isActiveSection(value) ? activeLinkClasses : ''}`}
                    onClick={onClick}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>
          ))}

          <div className="mt-4">
            <div className="uppercase font-bold text-lg mb-2 tracking-wider text-blue">Version History</div>
            <div className="flex flex-col gap-1">
              {versionsArray.map(v => {
                const versionLabel = formatVersion(v.version);
                const versionParamValue = toHashLabel(v.version);
                return (
                  <Link
                    key={v.version}
                    to={`?version=${versionParamValue}`}
                    className={`${linkBaseClasses} ${
                      isActiveVersion(versionParamValue) ? activeLinkClasses : ''
                    }`}
                    onClick={onClick}
                  >
                    Version {versionLabel}
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutSidebar;
